import * as d3 from 'd3';

export default class Abstract {
  constructor(props) {
    this.props = props;
    this.rangeStart = 0;
    this.rangeEnd = props.options.width;
    this.range = [this.rangeStart, this.rangeEnd];
    this.transitionDuration = 500;
  }

  get xScale() {
    return d3.scaleTime().domain(this.domain).range(this.range);
  }

  get yScale() {
    const {
      rows,
      options: { padding, height },
    } = this.props;

    return d3
      .scaleLinear()
      .domain([0, rows.length])
      .range([0 + padding, height - 32]);
  }

  get domain() {
    const { startDate, weekCount } = this.props.options;
    const startWeek = d3.timeWeek.floor(startDate);

    return [
      d3.timeWeek.offset(startWeek, -1),
      d3.timeWeek.offset(startWeek, weekCount - 1),
    ];
  }

  update() {
    return false;
  }
}
